import styles from '../../styles/Metrics.module.scss';
import { ExternalTripCountsData, VehicleClass, Settings } from '../../data/api';
import useTippy from '../../utils/use-tippy';
import {
    formatTotalTripsMetadataMessage,
    getExternalCountForPeriod,
} from '../../utils/external-trip-counts';
import { DataBucket } from './use-metrics';

interface MetricItemProps {
    name: string;
    value: number | undefined;
    unit: string | undefined;
    maximumFractionDigits?: number;
    tooltipText: string;
    timeRange?: string;
    vehicleClass?: VehicleClass;
    externalTripCounts?: ExternalTripCountsData | null;
    citySettings?: Settings;
    dataBuckets?: DataBucket[] | null;
}

function MetricItem({
    name,
    value,
    unit,
    maximumFractionDigits = 0,
    tooltipText,
    timeRange,
    vehicleClass,
    externalTripCounts,
    citySettings,
    dataBuckets,
}: MetricItemProps) {
    if (
        externalTripCounts &&
        getExternalCountForPeriod(
            timeRange,
            vehicleClass,
            externalTripCounts.tripCounts
        ) &&
        timeRange &&
        vehicleClass &&
        citySettings
    ) {
        const dataBucketsOrUndefined =
            dataBuckets === null ? undefined : dataBuckets;
        tooltipText = `${tooltipText} ${formatTotalTripsMetadataMessage(
            value ?? 0,
            timeRange,
            vehicleClass,
            externalTripCounts,
            citySettings.name,
            dataBucketsOrUndefined
        )}`;
    }
    const [metricItemRef] = useTippy<HTMLDivElement>(
        tooltipText ?? tooltipText,
        {
            placement: 'bottom',
            allowHTML: true,
            interactive: true,
            appendTo: () => document.body,
            showOnCreate:
                externalTripCounts !== null &&
                externalTripCounts != undefined &&
                value == undefined &&
                getExternalCountForPeriod(
                    timeRange,
                    vehicleClass,
                    externalTripCounts.tripCounts
                ) != null,
        }
    );
    const asterisk =
        externalTripCounts &&
        getExternalCountForPeriod(
            timeRange,
            vehicleClass,
            externalTripCounts.tripCounts
        )
            ? '*'
            : '';
    const displayValue = value
        ? value.toLocaleString(undefined, { maximumFractionDigits }) + asterisk
        : '-' + asterisk;
    const displayUnit = unit && value ? unit : null;

    return (
        <div ref={metricItemRef} className={styles.metric}>
            <span className={styles.name}>{name}</span>
            <div>
                <span className={styles.value}>{displayValue}</span>
                <span className={styles.unit}>{displayUnit}</span>
            </div>
        </div>
    );
}

export default MetricItem;
